import { render, staticRenderFns } from "./groupbuy_user.vue?vue&type=template&id=f4ef6e6a&scoped=true&"
import script from "./groupbuy_user.vue?vue&type=script&lang=js&"
export * from "./groupbuy_user.vue?vue&type=script&lang=js&"
import style0 from "./groupbuy_user.vue?vue&type=style&index=0&id=f4ef6e6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ef6e6a",
  null
  
)

export default component.exports